var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCabinetInstall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cabinet_installation",
    transform: "translate(-9.3 -7.3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 70,
    cy: 70,
    r: 70,
    transform: "translate(9.3 7.3)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2819",
    "data-name": "Group 2819"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 59.7,
    height: 20.1,
    transform: "translate(43.5 24.2)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 59.7,
    height: 83.8,
    transform: "translate(43.5 45.8)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 22.3,
    height: 2.4,
    transform: "translate(62.2 33.1)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 22.3,
    height: 2.4,
    transform: "translate(62.2 49.2)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    width: 46.7,
    height: 66.3,
    transform: "translate(50.1 56.6)",
    fill: "none",
    stroke: "#f0d8c7",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2821",
    "data-name": "Group 2821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M109.3,40h-2.2l-1.4,6,.6,2.4V86.8h3.9V48.4l.5-2.4Z",
    fill: "#fff",
    stroke: "#a5551c",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    width: 13.8,
    height: 38.1,
    rx: 1.8,
    transform: "translate(101.4 91.4)",
    fill: "#a5551c",
    stroke: "#f0d8c7",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M102.8,129.5h10.9v1a3.757,3.757,0,0,1-3.7,3.7h-3.4a3.757,3.757,0,0,1-3.7-3.7v-1h-.1Z",
    fill: "#a5551c",
    stroke: "#f0d8c7",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M102.8,86.7h10.9v1a3.757,3.757,0,0,1-3.7,3.7h-3.4a3.757,3.757,0,0,1-3.7-3.7v-1h-.1Z",
    fill: "#a5551c",
    stroke: "#f0d8c7",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2820",
    "data-name": "Group 2820"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    width: 1.8,
    height: 32.3,
    rx: 0.9,
    transform: "translate(103.1 94.4)",
    fill: "#fff",
    stroke: "#a5551c",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 1.8,
    height: 32.3,
    rx: 0.9,
    transform: "translate(107.2 94.4)",
    fill: "#fff",
    stroke: "#a5551c",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 1.8,
    height: 32.3,
    rx: 0.9,
    transform: "translate(111.5 94.4)",
    fill: "#fff",
    stroke: "#a5551c",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinetInstall);
export default __webpack_public_path__ + "static/media/CabinetInstall.b0373d6c701007988466bf41f3937902.svg";
export { ForwardRef as ReactComponent };